"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=elastic.collection.event.js.map